import { AIAgentAnalyticsItemModel } from "@jugl-web/rest-api/integrations/models/AIAgentAnalyticsItem/AIAgentAnalyticsItemModel";
import { useMemo } from "react";
import type { ImpactOverviewWidgetDataEntry } from "../components/ImpactOverviewWidget";

interface UseImpactOverviewWidgetDataOptions {
  analyticsData: AIAgentAnalyticsItemModel[];
}

export const useImpactOverviewWidgetData = ({
  analyticsData,
}: UseImpactOverviewWidgetDataOptions) => {
  const impactOverviewWidgetData = useMemo<
    ImpactOverviewWidgetDataEntry[]
  >(() => {
    const dict = analyticsData.reduce<Record<string, number>>((acc, item) => {
      const key = JSON.stringify([
        item.topic,
        item.subtopic,
        item.channel,
        item.country,
        item.businessImpact,
        item.sentiment,
      ]);

      acc[key] = (acc[key] || 0) + 1;

      return acc;
    }, {});

    const data = Object.entries(dict).map(([key, count]) => {
      const [topic, subtopic, channel, country, impact, sentiment] = JSON.parse(
        key
      ) as [
        topic: string,
        subtopic: string,
        channel: string,
        country: string | null,
        impact: string,
        sentiment: string
      ];

      return {
        id: key,
        topic,
        subtopic,
        channel,
        country,
        impact,
        sentiment,
        count,
      };
    });

    return data.sort((a, b) => b.count - a.count);
  }, [analyticsData]);

  return impactOverviewWidgetData;
};
